import { TypeManagerDecorator } from "../../main/type.map.service";
import { ChangeDetectionStrategy, Component, OnInit, signal, ViewEncapsulation } from "@angular/core";

import { DataIngestionService, IngestionSubmission } from "./data.ingestion.service";
import { IngestionFormComponent } from "./ingestion.form.component";

@TypeManagerDecorator("s25-ng-event-survey")
@Component({
    selector: "s25-ng-event-survey",
    template: `
        <div class="c-padding--double">
            @if (loading()) {
                <div class="loading-message">Loading survey...</div>
            } @else if (error()) {
                <div class="error-message">
                    <h2>Survey Not Found</h2>
                    <p>{{ error() }}</p>
                </div>
            } @else if (submission()) {
                <div class="event-survey-container">
                    <h1>Event Survey</h1>
                    <p class="survey-intro">Thank you for attending this event. We would appreciate your feedback.</p>
                    <s25-ng-ingestion-form
                        [submissionIdUuid]="submission()!.submissionIdUuid!"
                        [ingestionPointId]="submission()!.ingestionPointId!"
                        [readOnly]="submission()!.submitted || false"
                        (onSubmit)="onFormSubmit()"
                    ></s25-ng-ingestion-form>
                </div>
            }
        </div>
    `,
    styles: `
        :host {
            display: block;
        }

        .loading-message,
        .error-message {
            text-align: center;
            padding: 3rem;
        }

        .error-message h2 {
            color: #d32f2f;
            margin-bottom: 1rem;
        }

        .event-survey-container {
            max-width: 800px;
            margin: 0 auto;
        }

        .event-survey-container h1 {
            margin-bottom: 1rem;
            color: #2573a7;
        }

        .survey-intro {
            margin-bottom: 2rem;
            font-size: 1.1rem;
            color: #666;
        }
    `,
    encapsulation: ViewEncapsulation.Emulated,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [IngestionFormComponent],
})
export class EventSurveyComponent implements OnInit {
    readonly loading = signal(true);
    readonly error = signal<string | null>(null);
    readonly submission = signal<IngestionSubmission | null>(null);

    ngOnInit() {
        // Extract submissionIdUuid from URL hash (e.g., /#!/event-survey/<uuid>)
        const hash = window.location.hash;
        const match = hash.match(/event-survey\/([^\/]+)/);
        const submissionIdUuid = match ? match[1] : null;

        if (!submissionIdUuid) {
            this.error.set("Invalid survey link. Missing submission identifier.");
            this.loading.set(false);
            return;
        }

        this.loadSurvey(submissionIdUuid);
    }

    async loadSurvey(submissionIdUuid: string) {
        try {
            this.loading.set(true);
            this.error.set(null);

            const submission = await DataIngestionService.getEventSurveySubmission(submissionIdUuid);

            if (!submission) {
                this.error.set("Survey not found. It may have been deleted or the link may be invalid.");
                return;
            }

            this.submission.set(submission);
        } catch (err: any) {
            console.error("Failed to load event survey:", err);
            this.error.set(err?.message || "Failed to load survey. Please check your link and try again.");
        } finally {
            this.loading.set(false);
        }
    }

    onFormSubmit() {
        // Success message is rendered inline by s25-ng-ingestion-form.
    }
}
